import Tippy from "@tippyjs/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { OptionMenu } from "../../../../Components/Helper";
import more from "../../../../assets/more.png";
const TimelineItem = ({
  avatar,
  avatarColor,
  name,
  timestamp,
  message,
  isLast,
  formattedTime,
  commentId,
  userId,
  handleDeleteComment,
}) => {
  const { user } = useSelector((state) => state.user);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCommentDeletable,setIsCommentDeletable] = useState(false);

  const isCommentEditable = () => {
    const commentTime = new Date(timestamp);
    const currentTime = new Date();
    const timeDifferenceInMinutes = (currentTime - commentTime) / (1000 * 60);
    let isCommentDeletable= timeDifferenceInMinutes <= 5 && userId == user.id;
    setIsCommentDeletable(isCommentDeletable);
  };

  const handleMenuToggle = (e) => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuHide = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="timeline-item">
      <div className="timeline-avatar" style={{ backgroundColor: avatarColor }}>
        {avatar}
      </div>

      {!isLast && <div className="timeline-line"></div>}

      <div className="timeline-content">
        <div className="timeline-header">
          <div className="timeline-info">
            <span className="timeline-timestamp">{formattedTime},</span>
            <span className="timeline-name">{name}</span>
          </div>

          <div className="timeline-menu-container">
            {!user?.is_pdrl_admin && (
              <div>
                <Tippy
                  offset={[10, -15]}
                  interactive
                  visible={isMenuOpen}
                  onClickOutside={handleMenuHide}
                  onHide={handleMenuHide}
                  className="tippy"
                  arrow={false}
                  content={
                    <OptionMenu
                      isLeft
                      disableDelete={!isCommentDeletable}
                      onClickDelete={() => {
                        handleDeleteComment(commentId);
                        handleMenuHide();
                      }}
                    />
                  }
                >
                  <img
                    id="menu"
                    src={more}
                    alt="more"
                    style={{ width: "22px", cursor: "pointer" }}
                    onClick={(e)=>{
                    isCommentEditable();
                      handleMenuToggle(e)
                    }}
                  />
                </Tippy>
              </div>
            )}
          </div>
        </div>

        <div className="timeline-message font-manrope">{message}</div>
      </div>
    </div>
  );
};

export default TimelineItem;